import Router from "./router";
import Api from "./api";
import Layout from "./components/Layout";
import Store from "./store";
import { TelegramService } from "./tgService";

export default class App{
    constructor(){
        this.router = new Router(this);
        this.layout = null;
        this.store = new Store();
        this.telegram = new TelegramService(this.handleTgBack);
        // this.telegram = new TelegramService();
        this.api = new Api(this.store, this.telegram);
        this.pathStory = [];
    }

    async init(){
        
        this.layout = new Layout(this);
        // this.telegram = new TelegramService(this.handleTgBack);
        this.layout.render(document.getElementById('app'));
        this.router.init();
    }

    navigate(path){
        this.router.navigate(path);
    }

    // handleTgBack = ()=>{
    //     console.log("CLICK BACK BUTTON");
    // } 

    handleTgBack = () => {
            this.pathStory.pop();
            let path = this.pathStory.pop();
            if (path === undefined){
                path = '/';
            }
            console.log("HANDLE BACK to ", path);
            if(this.pathStory.length === 0){
                this.telegram.tg.BackButton.hide();
            }
            this.router.navigate(path);
    }

}